module.exports = __webpack_public_path__ + "media/images/favicn/favicon-16x16-d7ae444794e1a88b682e3f2d89435820.png";